import React from "react";

export const TimeSettingsContent = {
  variationTypes: {
    Any: "Any"
  },
  Any: {
    headerText: "Check your system time settings",
    message: (
      <p>
        Sorry you’re having trouble logging in. Please check you have the
        correct time and time zone selected on your device or computer. When the
        time settings are correct please click the Log in button below.
      </p>
    ),
    linkMessage: "Continue to login"
  }
};
